// ページ遷移時に使うノイズ
import * as THREE from 'three';
import { gsap } from 'gsap';

let initialized = false;
let scene, camera, renderer, group;
let meshes = [];
let horizontalDivisions;
let verticalDivisions;
let areaHeight;
let noiseHeight, noiseWidthUnit;
let colors = ['#0FFFFC', '#F425F9', '#FFFE08', "#E4EAF6"];
let noiseTarget;
let START_DURATION;
let END_DURATION;
let SP_START_DURATION;
let SP_END_DURATION;

export const pageLeaveAnimationPixel = () => {
  if (initialized) return;

  noiseTarget = document.querySelector('.pageLeaveAnimation');
  if (!noiseTarget) return;

  initialized = true;

  const isMobile = window.innerWidth <= 768;
  horizontalDivisions = isMobile ? 23 : 100;
  verticalDivisions = isMobile ? 65 : 65;
  START_DURATION = isMobile ? 0.005 : 0.001
  END_DURATION  = isMobile ? 0.001 : 0.00025
  scene = new THREE.Scene();
  camera = new THREE.OrthographicCamera(
    window.innerWidth / -2, window.innerWidth / 2,
    window.innerHeight / 2, window.innerHeight / -2,
    1, 1000
  );
  camera.position.z = 1;

  renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, precision: 'highp' });
  renderer.setSize(window.innerWidth, window.innerHeight);
  // renderer.setPixelRatio(1); // 軽量化のため固定
  // renderer.setPixelRatio(window.devicePixelRatio); // デバイスの解像度に応じて画質を最適化
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  noiseTarget.appendChild(renderer.domElement);

  group = new THREE.Group();
  scene.add(group);

  noiseHeight = window.innerHeight / verticalDivisions;
  noiseWidthUnit = window.innerWidth / horizontalDivisions;
  areaHeight = window.innerHeight / 10;

  animate();

  window.addEventListener('resize', () => {
    if (!renderer) return;

    const isMobile = window.innerWidth <= 768;
    horizontalDivisions = isMobile ? 20 : 100;
    verticalDivisions = isMobile ? 65 : 65;

    renderer.setSize(window.innerWidth, window.innerHeight);
    camera.left = window.innerWidth / -2;
    camera.right = window.innerWidth / 2;
    camera.top = window.innerHeight / 2;
    camera.bottom = window.innerHeight / -2;
    camera.updateProjectionMatrix();

    noiseHeight = window.innerHeight / verticalDivisions;
    noiseWidthUnit = window.innerWidth / horizontalDivisions;
    areaHeight = window.innerHeight / 10;
  });
};

function animate() {
  requestAnimationFrame(animate);
  if (renderer && scene && camera) {
    renderer.render(scene, camera);
  }
}

// -----------------------------
// メッシュ生成の実行（公開）
// -----------------------------
export const startNoisePhase = () => {
  if (!initialized) return;

  meshes.forEach(mesh => group.remove(mesh));
  meshes = [];

  let currentArea = 0;
  const sharedGeometry = new THREE.PlaneGeometry(1, 1);
  const createNoiseInArea = (startY) => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    const localNoiseHeight = height / verticalDivisions;
    const localNoiseWidthUnit = width / horizontalDivisions;

    const positions = Array.from({ length: horizontalDivisions * Math.ceil(areaHeight / localNoiseHeight) }, (_, i) => i).sort(() => Math.random() - 0.5);
    positions.slice(0, 600).forEach((pos, index) => {
      const delay = index * START_DURATION;
      gsap.delayedCall(delay, () => {
        const xIndex = pos % horizontalDivisions;
        const yIndex = Math.floor(pos / horizontalDivisions);

        const material = new THREE.MeshBasicMaterial({
          color: colors[Math.floor(Math.random() * colors.length)],
          vertexColors: false
        });

        const mesh = new THREE.Mesh(sharedGeometry, material);

        const randomWidthMultiplier = Math.floor(Math.random() * 4) + 1;
        const width = localNoiseWidthUnit * randomWidthMultiplier;
        const height = localNoiseHeight;

        mesh.scale.set(width, height, 1);
        mesh.position.set(
          (xIndex * localNoiseWidthUnit) - window.innerWidth / 2,
          startY + (yIndex * localNoiseHeight),
          0
        );

        group.add(mesh);
        meshes.push(mesh);
      });
    });
  };

  const interval = setInterval(() => {
    const startY = -window.innerHeight / 2 + currentArea * areaHeight;
    createNoiseInArea(startY);
    currentArea++;
    if (currentArea >= 10) clearInterval(interval);
  }, 60);
};

// -----------------------------
// 非表示処理（公開）
// -----------------------------
export const startDissolvePhase = () => {
  if (!initialized || meshes.length === 0) return;

  const reversed = meshes.slice().reverse();
  const totalDelay = reversed.length * END_DURATION;

  reversed.forEach((mesh, index) => {
    const delay = index * END_DURATION;
    gsap.delayedCall(delay, () => {
      mesh.visible = false;
    });
  });

  gsap.delayedCall(totalDelay, () => {
    group.clear();
    meshes = [];
  });
};
